module.exports = __webpack_public_path__ + "img/Original_Horizontal_Colored.6364405e.png";